<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <el-select
              class="select-default mb-3"
              style="width: 100%"
              v-model="filter_departments"
              collapse-tags
              filterable
              placeholder="Departamentos"
              @change="cleanSelect"
              multiple>
              <el-option
                class="select-default"
                v-for="item in departments"
                :key="item.CodeDpto"
                :label="item.NameDpto"
                :value="item.CodeDpto">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-select
              class="select-default mb-3"
              style="width: 100%"
              multiple
              filterable
              placeholder="Municipios"
              collapse-tags
              v-model="filter_municipalities">
              <el-option
                class="select-default"
                v-for="item in municipalities"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-date-picker
              style="width: 100%"
              :clearable="false"
              v-model="rangeDate"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="-"
              start-placeholder="Fecha Inicial"
              end-placeholder="Fecha Final"
              align="center">
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-3 text-center">
              <br class="c-none">
              <button type="button" class="btn btn-warning" @click="getFilteredData">Filtrar Datos</button>
          </div>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div v-if="canIndex()">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-6">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('Comportamiento_Red', 'Comportamiento de Red', 'a2', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('Comportamiento_Red', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('Comportamiento_Red', tableData, tableColumns)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      @selection-change="handleSelectionChange"
                      border
                      ref="tableModule">
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="text-right">
        <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportPDF('Comportamiento_Red', 'Comportamiento de Red', 'a2', tableData, tableColumns)"><i class="fa fa-file-pdf-o"></i>
            Exportar a PDF
        </button>
      </div>
    </div>
    <div class="col-4">
      <div class="text-center">
        <button oncli class="btn btn-success btn-fg custom-shadow-btn" @click="exportExcel('Comportamiento_Red', tableData, tableColumns)"><i class="fa fa-file-excel-o"></i>
        Exportar a Excel
      </button>
      </div>
    </div>
    <div class="col-4">
      <div class="text-left">
        <button class="btn btn-info btn-fg custom-shadow-btn" @click="exportCSV('Comportamiento_Red', tableData, tableColumns)"><i class="fa fa-file-text-o"></i>
          Exportar a CSV
        </button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import MixinDatePicker from "src/util/mixinDatePicker"
  import showSwalAlert from 'src/util/alerts'
  import swal from 'sweetalert2'
  import axios from 'axios'
  import moment from 'moment'
  import table from './deviceNetworkBehaviorTable'

  export default {
    data () {
      return {
        demandsForm: {},
        departments: [],
        municipalities: [],
        tableColumns: table,
        isShow: true,
        rangeDate: [new Date((new Date().getFullYear()), 0, 1), new Date((new Date().getFullYear()), 11 + 1, 0)]
      }
    },
    mixins: [mixinMasters, mixinPermissions, MixinDatePicker],
    methods: {
      handleView (index, row) {
        this.isShow = true
        this.rowData = Object.assign({}, row)
        this.title = this.rowData.name
        this.modals['read'] = true
      },
      getFilteredData() {
        let self = this
        this.$emit('cotentLoading', true)

        let data = {}
        data.route ='devicenetworkbehavior/index'
        data.filter_municipalities = (this.filter_municipalities.length == 0) ? '' : this.filter_municipalities.join()
        data.filter_departments = (this.filter_departments.length == 0) ? '' : this.filter_departments.join()
        data.init_date = moment(this.rangeDate[0]).format('YYYY-MM-DD')
        data.end_date = moment(this.rangeDate[1]).format('YYYY-MM-DD')

        this.saveMaster(data).then((response) => {
          this.tableData = response.data.deviceNetworkBehavior
          this.departments = response.data.departments
          this.municipalities = response.data.municipalities
          this.searchFuse(['Dpto', 'CodeMunicipio', 'CodeDpto', 'Municipio', 'Fecha', 'VelSubida', 'VelBajada', 'Host', 'Descripcion'])
          self.$emit('cotentLoading', false)
        }).catch((error) => {
          self.showMessageErrors(error)
          self.$emit('cotentLoading', false)
        })
      },
       handleSelectionChange(val) {
         console.log(val)
      },
/*       exportPDF() {
        let columns = [
          {title: "Región", dataKey: "Region"},
          {title: "Codigo Departamento", dataKey: "Dpto"},
          {title: "Departamento", dataKey: "Depart_Nombre"},
          {title: "Código Municipio", dataKey: "Municipio_Code"},
          {title: "Municipio", dataKey: "Municipio_Nombre"},
          {title: "Barrio", dataKey: "Barrio"},
          {title: "Dirección", dataKey: "Direccion"},
          {title: "Coordenadas", dataKey: "Coordenadas"},
          {title: "Item Code", dataKey: "ItemCode"},
          {title: "Item Name", dataKey: "ItemName"},
          {title: "Estado", dataKey: "Estado"},
          {title: "Stock", dataKey: "stock"},
          {title: "Cantidad", dataKey: "Cantidad"},
          {title: "MedidaV", dataKey: "MedidaV"},
          {title: "Fuente Financiación", dataKey: "FuenteFinanciación"},
          {title: "Fabricante", dataKey: "Fabricante"},
          {title: "Modelo", dataKey: "Modelo"},
          {title: "MAC", dataKey: "MAC"},
          {title: "Serial", dataKey: "Serial"},
        ]

        this.exportPDFFront(this.tableData, columns, 'Inventarios', 'Inventarios', 'a2')
      },
      exportExcel(){
        let datatable = JSON.parse(JSON.stringify(this.tableData));

        let myHeader = [
          "Region", "Dpto", "Depart_Nombre", "Municipio_Code", "Municipio_Nombre", "Barrio", "Direccion",
          "Coordenadas", "ItemCode", "ItemName", "Estado", "stock", "Cantidad", "MedidaV", "FuenteFinanciación",
          "Fabricante", "Modelo", "MAC", "Serial"
        ]

        let myHeaderTrans = [
          "Región", "Codigo Departamento", "Departamento", "Código Municipio",
          "Municipio", "Barrio",  "Dirección", "Coordenadas",  "Código",  "Elemento",
          "Estado", "Stock",  "Cantidad", "MedidaV", "Fuente Financiación", "Fabricante",
          "Modelo",  "MAC", "Serial"
        ]

        datatable.forEach( (elem) => {
          for (const key in elem) {
            if (!(myHeader.includes(key))) delete elem[key]
          }
        })

        this.exportExcelFront(datatable, myHeader, myHeaderTrans, 'Inventarios')
      },
      exportCSV(){
        let csv = this.$papa.unparse({
          'data': this.tableData,
          'transformHeader': [
            "Region", "Dpto", "Depart_Nombre", "Municipio_Code", "Municipio_Nombre", "Barrio", "Direccion",
            "Coordenadas", "ItemCode", "ItemName", "Estado", "stock", "Cantidad", "MedidaV", "FuenteFinanciación",
            "Fabricante", "Modelo", "MAC", "Serial"
          ]
        })
        this.$papa.download(csv, 'inventarios')
      }   */
    },
    created(){
      this.$emit('cotentLoading', true)
      if(this.canIndex()){
        this.getFilteredData()
      }
    },
  }
</script>
<style>
</style>
